import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

export interface CustomerCentreActiveUploadItem {
  id: string;
  org_id: string;
  file: File;
  status: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';
}

interface CustomerCentreUploadStore {
  activeUploads: Array<CustomerCentreActiveUploadItem>;
}

const useCustomerCentreActiveUploadStore = createWithEqualityFn<CustomerCentreUploadStore>(
  () => ({
    activeUploads: [],
  }),
  shallow
);

export const useListCustomerCentreActiveUploads = () =>
  useCustomerCentreActiveUploadStore(
    (state) => state.activeUploads.filter((item) => item.status === 'IN_PROGRESS'),
    shallow
  );

export const addCustomerCentreActiveUploadFn = (upload: Array<CustomerCentreActiveUploadItem>) =>
  useCustomerCentreActiveUploadStore.setState((state) => ({
    activeUploads: [...state.activeUploads, ...upload],
  }));

export const onCustomerCentreUploadSuccessCallback = (id: string) =>
  useCustomerCentreActiveUploadStore.setState((state) => ({
    activeUploads: state.activeUploads.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          status: 'SUCCESS',
        };
      }
      return item;
    }),
  }));

export const onCustomerCentreUploadFailedCallback = (id: string) =>
  useCustomerCentreActiveUploadStore.setState((state) => ({
    activeUploads: state.activeUploads.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          status: 'FAILED',
        };
      }
      return item;
    }),
  }));
